var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"l-ft"},[_c('div',{staticClass:"l-smry"},[_c('h3',{staticClass:"h"},[_vm._v(_vm._s(_vm.$t('shopping.overview_title')))]),_c('purchaseSummary',{attrs:{"props":_vm.props}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }